import { Box } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'

type LoadingProps = {
  height?: string
  width?: string
}

export const Loading = ({ height, width }: LoadingProps) => (
  <Box
    display='flex'
    flexDirection='column'
    justifyContent='center'
    alignItems='center'
    height={height || '100vh'}
    width={width || '100%'}
    gap={2}
  >
    <CircularProgress />
  </Box>
)
